import React, { Component } from "react";

class Header extends Component {
  render() {
    return (
      <header className="app-header position-center">
        <img className="header-logo" src="/logo_both.png" alt="7-Eleven logo" />
      </header>
    );
  }
}

export default Header;
